module.exports = __webpack_public_path__ + "static/media/django-blog.3ed0ce33.png";